import { render, staticRenderFns } from "./RoleActions.vue?vue&type=template&id=37b19c1c&"
import script from "./RoleActions.vue?vue&type=script&lang=js&"
export * from "./RoleActions.vue?vue&type=script&lang=js&"
import style0 from "./RoleActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports